(function() {
  function init() {
    var nav = document.getElementById('hw-h2-sticky-nav');
    if (!nav) return;

    var NAV_H = nav.offsetHeight || 52;
    var section = nav.closest('[id^="shopify-section"]');

    // Force section wrapper to be sticky (same as H2 Mini)
    if (section) {
      section.style.position = 'sticky';
      section.style.top = '0';
      section.style.zIndex = '1000';
      section.style.background = '#fff';
    }

    // Inject #hw-overview anchor before first detail section
    var firstDetailEl = document.querySelector('[id*="shopify-section"][id*="slideshow_MPqWmL"]');
    if (firstDetailEl && !document.getElementById('hw-overview')) {
      firstDetailEl.insertAdjacentHTML('beforebegin',
        '<span id="hw-overview" style="display:block;height:0;"></span>');
    }

    // Find header for opacity hiding
    var headerSection = document.querySelector('.shopify-section--header');
    if (headerSection) {
      
    }

    // Sentinel approach — identical to H2 Mini
    if (section) {
      var sentinel = document.createElement('div');
      sentinel.style.cssText = 'height:1px;margin-bottom:-1px;visibility:hidden;pointer-events:none;';
      section.parentNode.insertBefore(sentinel, section);

      var obs = new IntersectionObserver(function(entries) {
        var entry = entries[0];
        // Only "stuck" when sentinel scrolled ABOVE viewport (top < 0)
        var stuck = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        section.classList.toggle('is-stuck', stuck);
        if (headerSection) {
          headerSection.style.opacity = stuck ? '0' : '';
          headerSection.style.pointerEvents = stuck ? 'none' : '';
        }
      }, { threshold: 0 });
      obs.observe(sentinel);
    }

    // Smooth scroll on click
    nav.querySelectorAll('.hw-sticky-nav__item').forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.scrollY - NAV_H - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();